export default __webpack_public_path__ + "static/media/program_intro_11.9d3a4755.png";